import React from 'react';

const Footer = () => {
  const handleEmail = () => {
    window.location.href = "mailto:contato.revisa.ja.aposentadoria@gmail.com?subject=Fazer Revisão - Anexar carta e Cnis em pdf"
  };

  const handleWhatsappClick = (phone, message = "") => {
    // Cria a URL base do WhatsApp
    let url = `https://wa.me/${phone}`;

    // Se houver uma mensagem, adiciona ela formatada na URL
    if (message) {
      url += `?text=${encodeURIComponent(message)}`;
    }

    // Abre o WhatsApp em uma nova aba
    window.open(url, '_blank');
  };

  return (
    <div className="footer-nova"> {/* Esta é a classe principal */}
      <footer>
        <img src="/assets/balanca_amarela.png" alt="Balança" className="footer-icon" />

        <div className="footer-section">
          <h3>Endereço</h3>
          <p>Rua Viúva Dantas, 80 - Sala 312, Campo Grande</p>
          <p>Rio de Janeiro CEP 23.052-090</p>
        </div>


        <div className="footer-section">
          <h3>Atendimento</h3>
          <p> De segunda a sexta, das 09:00 hs às 17:00 hs</p>
        </div>



<div className="footer-section">
          <h3>Contato</h3>
          
          {/* E-MAIL */}
          <p 
            className="email-container" 
            onClick={typeof handleEmail !== 'undefined' ? handleEmail : undefined} 
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" className="email-icon">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
            <span>contato.revisa.ja.aposentadoria@gmail.com</span>
          </p>

          {/* WHATSAPP */}
          <p
            className="whatsapp-container"
            onClick={() => handleWhatsappClick("5521993298688", "Olá! Acessei o site e gostaria de fazer a revisão da minha aposentadoria. - Anexar carta de concessão e CNIS")}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" className="whatsapp-icon">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
            </svg>
            <span>(21) 99329-8688</span>
          </p>

        </div>



        <div className="footer-section">
          <h3>Nos siga na rede social</h3>
          <a href="https://www.youtube.com/@RevisaJaAposentadoria/shorts" target="_blank" rel="noreferrer" className="yt-link">
            {/* Ícone do YouTube em SVG */}
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              width="20"
              height="20"
              className="yt-icon"
            >
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
            <span>Youtube</span>
          </a>
        </div>

        <div className="footer-bottom">
          <p className='paragrafo-novo'>© 2026 <strong>Revisa Já Aposentadoria</strong></p>

        
        <p className='paragrafo-novo'>
          CNPJ: 68.027.310/0001-33</p>
          
          <p className='paragrafo-novo'>Todos os Direitos Reservados.</p>
        </div>


      </footer>
    </div>
  );
};

export default Footer;